import { type FC } from "react";
import { Grid, IconButton, Paper, Typography } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

interface ApiKeyValueRowProps {
	readonly label: string;
	readonly value: string;
	readonly copyButtonPendoId: string;
	readonly onCopyToClipboard: (value: string) => void;
}

export const ApiKeyValueRow: FC<ApiKeyValueRowProps> = ({ label, value, copyButtonPendoId, onCopyToClipboard }) => {
	return (
		<Grid container direction="column" wrap="nowrap" gap={0.5}>
			<Typography fontWeight={500}>{label}</Typography>
			<Paper
				component={Grid}
				container
				wrap="nowrap"
				variant="outlined"
				justifyContent="space-between"
				alignItems="center"
				sx={{ p: 2 }}
			>
				<Typography noWrap>{value}</Typography>
				<IconButton size="small" onClick={() => onCopyToClipboard(value)} data-pendoid={copyButtonPendoId}>
					<ContentCopyOutlinedIcon sx={{ fontSize: 20 }} />
				</IconButton>
			</Paper>
		</Grid>
	);
};
